export default __webpack_public_path__ + "static/media/iconDropHere.89694ee9.svg";